import {Grid} from "@mui/system";

import pxToRem from "hooks/usePxToRem";

import {DefaultCardStructure} from "components";
import {Controller, useFormContext} from "react-hook-form";
import ProcessTextField from "views/ProcessDetails/refactor/components/ProcessTextField";
import useOriginalOrAlternativeValue from "hooks/useOriginalOrAlternativeValue";

const Payment = () => {
  const {control} = useFormContext();
  const {valueOrEmptyString} = useOriginalOrAlternativeValue();

  return (
    <DefaultCardStructure
      title="Pagamento"
      hasDivider={false}
      isSubcard
      titleMarginBottom={12}
    >
      <Grid container rowSpacing={pxToRem(10)} columnSpacing={pxToRem(4)}>
        <Grid size={5}>
          <Controller
            name="charges.typePayment"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.typePayment"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Tipo pagamento"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={2}>
          <Controller
            name="charges.quantityPayment"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.quantityPayment"
                type="text"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Quantidade"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={5}>
          <Controller
            name="charges.payTo"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.payTo"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Pagar para"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={12}>
          <Controller
            name="charges.paymentPerson"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.paymentPerson"
                type="text"
                value={valueOrEmptyString(value?.name)}
                onChange={onChange}
                size="small"
                disabled
                label="Pessoa"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={2.4}>
          <Controller
            name="charges.paymentCurrency"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.paymentCurrency"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Moeda"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={2.1}>
          <Controller
            name="charges.valuePaymentUnit"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.valuePaymentUnit"
                type="text"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Valor unitário"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={2.1}>
          <Controller
            name="charges.valuePaymentMinimum"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.valuePaymentMinimum"
                type="text"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Valor mínimo"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={2.1}>
          <Controller
            name="charges.valuePaymentTotal"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.valuePaymentTotal"
                type="text"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Valor total"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={3.3}>
          <Controller
            name="charges.modalityPayment"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.modalityPayment"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Modalidade"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid size={4.5}>
          <Controller
            name="charges.billingPayment"
            control={control}
            render={({field: {onChange, value}}) => (
              <ProcessTextField
                name="charges.billingPayment"
                value={valueOrEmptyString(value)}
                onChange={onChange}
                size="small"
                disabled
                label="Faturamento"
                fullWidth
              />
            )}
          />
        </Grid>
      </Grid>
    </DefaultCardStructure>
  );
};

export default Payment;
